import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-tent",
  "use": "icon-th-tent-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-tent\">\n<path d=\"M31.9137 24.5938L23.9137 6.59375C23.8352 6.41702 23.707 6.26686 23.5448 6.16148C23.3827 6.05609 23.1934 6 23 6H8.99999C8.80825 6.00031 8.62065 6.05574 8.45953 6.15969C8.29841 6.26363 8.17057 6.41169 8.09124 6.58625C8.09088 6.58874 8.09088 6.59126 8.09124 6.59375V6.60875L0.0862383 24.5938C0.0185488 24.746 -0.0100246 24.9128 0.0031141 25.0789C0.0162528 25.245 0.0706872 25.4051 0.161471 25.5449C0.252256 25.6846 0.376512 25.7994 0.522951 25.8789C0.669389 25.9584 0.833368 26 0.999988 26H31C31.1666 26 31.3306 25.9584 31.477 25.8789C31.6235 25.7994 31.7477 25.6846 31.8385 25.5449C31.9293 25.4051 31.9837 25.245 31.9969 25.0789C32.01 24.9128 31.9814 24.746 31.9137 24.5938ZM7.99999 24H2.53874L7.99999 11.7125V24ZM9.99999 24V11.7125L15.4612 24H9.99999ZM17.65 24L10.5387 8H22.35L29.4612 24H17.65Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-tent.svg
// module id = tyXI
// module chunks = 84